import { render, staticRenderFns } from "./blogroll.vue?vue&type=template&id=21bae209&scoped=true&"
import script from "./blogroll.vue?vue&type=script&lang=js&"
export * from "./blogroll.vue?vue&type=script&lang=js&"
import style0 from "./blogroll.vue?vue&type=style&index=0&id=21bae209&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bae209",
  null
  
)

export default component.exports